import dxNotify from "devextreme/ui/notify";

// Wspólny stos dla wszystkich toastów w aplikacji, dzięki czemu DevExtreme
// układa je jeden pod drugim zamiast nakładać w tej samej pozycji.
const sharedStack = {
  position: "bottom center" as const,
  direction: "up-stack" as const,
};

type NotifyOptions = Record<string, unknown>;

/**
 * Wrapper na DevExtreme notify dodający wspólny `stack`, aby toasty się
 * układały (nie nakładały). Zachowuje obie sygnatury oryginału:
 *   notify(message, type?, displayTime?)
 *   notify(options, type?, displayTime?)
 */
function notify(
  messageOrOptions: string | NotifyOptions | undefined,
  type?: string,
  displayTime?: number,
): void {
  const options: NotifyOptions =
    messageOrOptions === undefined || typeof messageOrOptions === "string"
      ? { message: messageOrOptions ?? "" }
      : { ...messageOrOptions };

  if (type !== undefined && options.type === undefined) {
    options.type = type;
  }

  if (displayTime !== undefined && options.displayTime === undefined) {
    options.displayTime = displayTime;
  }

  dxNotify(options, sharedStack);
}

export default notify;
